import errorToNotifObj from "./errorToNotif"
import Swal from 'sweetalert2'
import moment from 'moment';
import "moment/min/locales.min"
import {PERSMISOS, PERSMISOS_USUARIOS, TIPOPAGO, TIPOPLAN, TIPO_USUARIO, getValueString} from "./CONSTANTES"
import {getTokenInfo} from "../services/auth";
import geoString from "./geoString"
import Strings from "../assets/strings";
import _ from "lodash";
import {store} from "../redux/store";


export function getLSLang(tipo) {

    // const { CountryCode= "DO" } = getTokenInfo();
    let {paisCodigo = "DO"} = store.getState()?.companias?.data ?? {};


    const langLS = localStorage.getItem('lang');

    let lang = (langLS === "en") ? "en" : "es";


    switch (tipo) {
        case "l":
            return lang;
        case "c":
            return paisCodigo ?? "DO";
        default:
            return lang+"-"+(paisCodigo ?? "DO");
    }


}
moment.locale("es"); //getLSLang("l")
export function setLSLang(lang) {
    if(["es", "en"].includes(lang)){
        localStorage.setItem("lang", lang)
    }
}
export function formatDate(date, format="DD/MM/YYYY") { //h:mm a
    moment.locale(getLSLang("l"));
    if(!date)
        return "";

   return moment(date).format(format);

    // format = "DD/MM/YYYY";
    //
    // let fecha =  moment(date).calendar(null,{
    //     // lastDay : '[Yesterday]',
    //     // sameDay : '[Hoy]',
    //     // nextDay : '[Tomorrow]',
    //     lastWeek : format,
    //     nextWeek : format,
    //     sameElse : format});
    //
    // fecha = fecha.includes("a la") || fecha.includes("at") ? fecha.split(" ")[0] : fecha;
    //
    // return fecha?.charAt(0).toUpperCase() + fecha.slice(1)


}

export {moment};
export function formatPeso(val,maxFraction = 2) {
    let value = val ? parseFloat(val): 0;
    let {moneda = "DOP"} = store.getState()?.companias?.data ?? {};

    const paises = [
        {paiCodigo: "DO",paiModeneda: "DOP", paiIdioma:"es"},
        {paiCodigo: "US",paiModeneda: "USA", paiIdioma:"en"},
        {paiCodigo: "ES",paiModeneda: "EUR", paiIdioma:"es"},
        {paiCodigo: "BO",paiModeneda: "BOB", paiIdioma:"es"},
        {paiCodigo: "CO",paiModeneda: "COP", paiIdioma:"es"},
        {paiCodigo: "CR",paiModeneda: "CRC", paiIdioma:"es"},
        {paiCodigo: "PY",paiModeneda: "PYG", paiIdioma:"es"},
        {paiCodigo: "GT",paiModeneda: "GTQ", paiIdioma:"es"},
        {paiCodigo: "VE",paiModeneda: "VES", paiIdioma:"es"},
        {paiCodigo: "PE",paiModeneda: "PEN", paiIdioma:"es"},
        {paiCodigo: "HN",paiModeneda: "HNL", paiIdioma:"es"},
        {paiCodigo: "NI",paiModeneda: "NIO", paiIdioma:"es"},
        {paiCodigo: "PA",paiModeneda: "PAB", paiIdioma:"es"},
        {paiCodigo: "MX",paiModeneda: "MXN", paiIdioma:"es"},
        {paiCodigo: "AR",paiModeneda: "ARS", paiIdioma:"es"},
        {paiCodigo: "CL",paiModeneda: "CLP", paiIdioma:"es"},
        {paiCodigo: "UY",paiModeneda: "UYU", paiIdioma:"es"}
    ];
    let monedaDisponible = paises.find(p=>p.paiModeneda === moneda?.toUpperCase());

    //si no se encuentra la moneda poner una universal
    if(!monedaDisponible){
        return '$' + parseFloat(value)
            .toFixed(maxFraction)
            .replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    }

    //  if (countryCode && typeof Intl == 'object' && typeof Intl.NumberFormat == 'function' && monedaDisponible){
        return value.toLocaleString(monedaDisponible.paiIdioma+"-"+monedaDisponible.paiCodigo, {
            style: 'currency',
            currency: monedaDisponible.paiModeneda,
            minimumFractionDigits: 0,
            maximumFractionDigits: maxFraction,
        }).replace("DOP","$").replace("USA","$");
   // }


}
export const alertNote = msj => ()=>{
    Swal.fire(msj, {
        buttons: false,
        className: "alertNote",
    });
};

export function nullToEmptyString(obj,noCero) {
    let newObj = {};
    Object.keys(obj).forEach((prop) => {
        newObj[prop] = obj[prop] == null || (noCero && obj[prop] === 0)  ? obj[prop] = "" : obj[prop];
    });
    return newObj;
}

export function noTilde(input) {
    var r = input?.toLowerCase() ?? "";
    r = r.replace(new RegExp(/\s/g), "");
    r = r.replace(new RegExp(/[àáâãäå]/g), "a");
    r = r.replace(new RegExp(/æ/g), "ae");
    r = r.replace(new RegExp(/ç/g), "c");
    r = r.replace(new RegExp(/[èéêë]/g), "e");
    r = r.replace(new RegExp(/[ìíîï]/g), "i");
    r = r.replace(new RegExp(/ñ/g), "n");
    r = r.replace(new RegExp(/[òóôõö]/g), "o");
    r = r.replace(new RegExp(/œ/g), "oe");
    r = r.replace(new RegExp(/[ùúûü]/g), "u");
    r = r.replace(new RegExp(/[ýÿ]/g), "y");
    r = r.replace(new RegExp(/\W/g), "");
    return r;
}


export function getRestriccionesList() {
    const {Restrictions} = getTokenInfo();
    let restriccionesList = [];
    if(Restrictions && Restrictions.length > 1){
        try {
            restriccionesList = Restrictions.split(",").map(r=>parseInt(r));
        }catch (e) {
            throw e;
        }
    }
    return restriccionesList
}
export function hasPermissionTo(idperId) {

    if(getUsuTipo() === TIPO_USUARIO.sistema ){
        return getRestriccionesList().indexOf(idperId) === -1;
    }else if(getUsuTipo() === TIPO_USUARIO.farmacia ){
        const permiso = getValueString(PERSMISOS, idperId).toLowerCase();
        const palabrasClave = ["pharmaciesUpdate", "pharmaciesCreate", "pharmaciesDelete", "pharmaciesChangeStatus", "pharmaciesExport",
            "pharmaciesGenerateUser", "pharmaciesViewUser", "productsCreate", "productsUpdate", "productsDelete","productsExport"];


       return  !palabrasClave.some(palabra => permiso.includes(palabra.toLowerCase()));

    }else{
        return true;
    }


}
export function hasModule(molduleId) {
    const {CompanyModules = ""} = getTokenInfo();
    let comMod = CompanyModules.split(",").map(i=>parseInt(i))

    return getUsuTipo() === TIPO_USUARIO.admin || comMod?.includes(molduleId)
}
export function getUsuTipo() {
    const {Type} = getTokenInfo();
    return parseInt(Type);
}
export function checkDateInput() {
    let input = document.createElement('input');
    input.setAttribute('type','date');

    let notADateValue = 'not-a-date';
    input.setAttribute('value', notADateValue);

    return (input.value !== notADateValue);
}



const translateText = (text="") => {
    return Strings[_.camelCase(text)] || _.upperFirst(_.toLower(_.startCase(text)))
    // return Strings[text?.includes("_") ? text : _.camelCase(text)] || text;
}
const imageUrlToBase64 = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
            const base64data = reader.result;
            resolve(base64data);
        };
        reader.onerror = reject;
    });
};

const diffDuration = (date1, date2 = new Date(), mostrarMeses = true, mostrarDias = false)=>{
    let v = "";
    if(date1 && date2){
        var diffDuration = moment.duration(moment(date2).diff(moment(date1)));
        let anos = diffDuration.years();
        let meses = diffDuration.months();
        let dias = diffDuration.days();
        if (anos > 0){
            v += anos +" año"+(anos > 1 ? "s":"")
            if(!!mostrarMeses) {
                v += (meses || (dias && !!mostrarDias) ? (!mostrarDias || !dias ? " y " : ", ") : "");
            }
        }
        if(!mostrarMeses){
            return v
        }


        if (meses > 0){
            v += meses +" mes"+(meses > 1 ? "es":"")+(mostrarDias && dias ? ", ":"");

        }
        if (!!mostrarDias && dias > 0){
            v += dias +" día"+(dias > 1 ? "s":"");

        }


    }
    return v
}
export {diffDuration, imageUrlToBase64, translateText,errorToNotifObj,PERSMISOS,PERSMISOS_USUARIOS,TIPO_USUARIO,TIPOPAGO,TIPOPLAN,geoString}
